<p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>

<div class="clean-table-container" *ngIf="fleetChecklist$ | async as checklist">
  <div class="table-validation-responsive">
    <table class="clean-table align-middle">
      <thead>
        <tr>
          <th class="text-center checkbox-col">
            <!-- <i class="pi pi-check-circle" style="font-size: 1.1rem; color: #64748b;" title="Estado de Inspección"></i> -->
            <p-checkbox
              [binary]="true"
              [ngModel]="allCompleted"
              (ngModelChange)="toggleAllCompletion($event)"
              [disabled]="!store.isEditable()">
            </p-checkbox>
          </th>
          <th class="text-center">#</th>
          <th>UNIDAD</th>

          <ng-container *ngIf="checklist?.type == 'interno' || checklist?.type == 'externo'">
            <th>COD.UMA</th>
          </ng-container>
          <th>PLACA</th>
          <th *ngFor="let field of checklist.fields; trackBy: trackByFieldId" class="field-col">
            {{ field.name }}
          </th>
          <th
            *ngFor="let criteria of checklist.criteria; trackBy: trackByCriterionId"
            class="criteria-col"
            [ngClass]="{
              'principal-criterion-header': isPrincipalCriterion(criteria),
              'camera-criterion': isCameraCriterion(criteria)
            }"
          >
            {{ criteria.name }}
          </th>
          <th class="observation-col"> Observación</th>
          <th class="text-center actions-col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let vehicle of vehicles$ | async; let i = index; trackBy: trackByVehicleId" [ngClass]="{
          'row-completed': vehicle.status == 'completed',
          'row-review': vehicle.status == 'inReview',
          'row-observation': vehicle.status == 'observation'
        }">
          <td class="text-center checkbox-col">
            <p-checkbox
              [binary]="true"
              [ngModel]="vehicle.status == 'completed' || vehicle.status == 'inReview' || vehicle.status == 'observation'"
              (ngModelChange)="toggleCompletion(vehicle)"
              [disabled]="!store.isEditable() || !isVehicleComplete(vehicle)">
            </p-checkbox>
          </td>
          <td class="text-center">{{ i + 1 }}</td>
          <td>
            <span class="badge-unit">{{ vehicle.unitCode }}</span>
          </td>
          <ng-container *ngIf="checklist?.type == 'interno' || checklist?.type == 'externo'">
            <td>
              <span class="badge-unit">{{ vehicle.umaCode }}</span>
            </td>
          </ng-container>
          <td>
            <span class="badge-plate">{{ vehicle.plate }}</span>
          </td>

          <td *ngFor="let field of checklist.fields; trackBy: trackByFieldId" class="text-center field-col">

            <ng-container [ngSwitch]="field.type">


              <div
              [ngClass]="{
                'priority-warning': isPriorityFieldLocked(vehicle, field)
              }">
                <!-- Hora -->
                <p-calendar *ngSwitchCase="'time'" [ngModel]="vehicle.fields[field.id].value"
                  (ngModelChange)="onFieldValueChange(vehicle.id, field.id, $event)" [timeOnly]="true" hourFormat="24"
                  styleClass="custom-time-picker" inputStyleClass="custom-time-input" appendTo="body"
                  [disabled]="checklist?.status !== 'pending' || (vehicle.status == 'inReview' || vehicle.status == 'completed' || vehicle.status == 'observation')" placeholder="Hora">
                </p-calendar>

                <p-autoComplete *ngSwitchCase="'autocomplete'" [(ngModel)]="vehicle.fields[field.id].value"
                  [suggestions]="fieldSuggestions[field.id] || []" (completeMethod)="filterSuggestions($event, field)"
                  (onFocus)="openSuggestions($event, field)"
                  (ngModelChange)="onFieldValueChange(vehicle.id, field.id, $event)" [forceSelection]="false"
                  [dropdown]="false" [minLength]="0" styleClass="custom-autocomplete"
                  [disabled]="checklist?.status !== 'pending' || (vehicle.status == 'inReview' || vehicle.status == 'completed' || vehicle.status == 'observation')"
                  placeholder="Seleccione..." appendTo="body">
                </p-autoComplete>

                <!-- Campo Texto -->
                <input *ngSwitchCase="'text'" class="clean-input-obs text-uppercase" type="text"
                  [(ngModel)]="vehicle.fields[field.id].value"
                  (ngModelChange)="onFieldValueChange(vehicle.id, field.id, $event)"
                  [disabled]="checklist?.status !== 'pending' || (vehicle.status == 'inReview' || vehicle.status == 'completed' || vehicle.status == 'observation')" placeholder="...">

                <!-- Campo Número -->
                <input *ngSwitchCase="'number'" class="clean-input-obs" type="number"
                  [(ngModel)]="vehicle.fields[field.id].value"
                  (ngModelChange)="onFieldValueChange(vehicle.id, field.id, $event)"
                  [disabled]="checklist?.status !== 'pending' || (vehicle.status == 'inReview' || vehicle.status == 'completed' || vehicle.status == 'observation')">

                <span *ngSwitchDefault>-</span>
              </div>
            </ng-container>

            <!-- Campo Texto -->
            <ng-template #textField>
              <input class="clean-input-obs text-uppercase" type="text" [(ngModel)]="vehicle.fields[field.id].value"
                (ngModelChange)="onFieldValueChange(vehicle.id, field.id, $event)"
                [disabled]="checklist?.status !== 'pending' || (vehicle.status == 'inReview' || vehicle.status == 'completed' || vehicle.status == 'observation')" placeholder="...">
            </ng-template>
          </td>

          <td *ngFor="let criterion of checklist.criteria; trackBy: trackByCriterionId" class="text-center criteria-col" [class.camera-criterion]="isCameraCriterion(criterion)">

            <div class="criterion-cell-content">
              <div class="criterion-wrapper">
                <ng-container *ngIf="vehicle.criteria[criterion.id]; else noCriterion">
                  <ng-container
                    *ngIf="checklist?.status !== 'pending' || (vehicle.status == 'inReview' || vehicle.status == 'completed' || vehicle.status == 'observation'); else editableState">

                    <span class="status-pill" [ngClass]="getCriterionStateClass(vehicle, criterion)">
                      {{ getCriterionStateName(vehicle, criterion) }}
                    </span>

                  </ng-container>

                  <ng-template #editableState>
                    <span class="status-pill" [ngClass]="getCriterionStateClass(vehicle, criterion)"
                      [class.editable]="true" (click)="toggleCriterionState(vehicle, criterion)">
                      {{ getCriterionStateName(vehicle, criterion) }}
                    </span>
                  </ng-template>

                </ng-container>

                <ng-template #noCriterion>
                  <span class="na-badge">N/A</span>
                </ng-template>

                <!-- Información de transmisión fija -->
                <div class="criterion-info-box" *ngIf="getTransmissionData(vehicle, criterion) as txData">
                  <div class="info-header">
                    <span class="status-dot" [style.background-color]="txData.statusColor"></span>
                    <strong>{{ txData.statusName }}</strong>
                  </div>
                  <div class="info-body">
                    <div class="info-row" *ngIf="txData.lastStartTime">
                      <span class="value">{{ txData.lastStartTime | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                    </div>
                  </div>
                </div>

                <!-- Información de equipamiento fija -->
                <div class="criterion-info-box" *ngIf="getEquipmentData(vehicle, criterion) as eqData">
                  <div class="info-body">
                    <div class="info-header" *ngIf="eqData.lastEventName">
                      <span class="value">{{ eqData.lastEventName }}</span>
                    </div>
                    <div class="info-row" *ngIf="eqData.lastEventDate">
                      <span class="value">{{ eqData.lastEventDate | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                    </div>
                  </div>
                </div>

              </div>


              <div class="evidence-direct-action" *ngIf="isCameraCriterion(criterion)">
                <button type="button"
                  class="btn-evidence-upload-premium"
                  (click)="uploadEvidence(vehicle)"
                  [class.has-evidence]="hasEvidences(vehicle, criterion)"
                  [title]="hasEvidences(vehicle, criterion) ? 'Ver evidencias (' + (vehicle.parameters?.evidences?.length || 0) + ')' : 'Subir evidencia'">
                  <i class="material-icons">{{ hasEvidences(vehicle, criterion) ? 'photo_camera' : 'add_a_photo' }}</i>
                  <span class="evidence-badge" *ngIf="hasEvidences(vehicle, criterion)">{{ vehicle.parameters?.evidences?.length }}</span>
                </button>
              </div>
            </div>
          </td>

          <!-- OBSERVACION -->
          <td class="observation-col">
            <input type="text" class="clean-input-obs" [ngModel]="vehicle.observations"
              (ngModelChange)="onObservationsChange(vehicle.id, $event)"
              [disabled]="checklist?.status !== 'pending' || (vehicle.status == 'inReview' || vehicle.status == 'completed' || vehicle.status == 'observation')"
              placeholder="Añadir observación...">
          </td>

          <!-- ACCIONES -->
          <td class="text-center actions-col">
            <button pButton type="button" icon="pi pi-ellipsis-v"
              class="p-button-rounded p-button-text p-button-sm"
              (click)="toggleMenu($event, vehicle, menu)"
              [disabled]="!store.isEditable()">
            </button>
          </td>
        </tr>
        <tr *ngIf="(vehicles$ | async)?.length === 0">
          <td [attr.colspan]="checklist.fields.length + checklist.criteria.length + 7"
            class="text-center py-5 text-muted">
            <i class="material-icons d-block mb-2" style="font-size: 32px; opacity: 0.5;">info</i>
            No hay vehículos en este grupo.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
